import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { OnboardingService } from '../onboarding.service';
import { LoaderService } from '../../utils/loader.service';

@Component({
  selector: 'app-terms',
  templateUrl: './terms.component.html',
  styleUrls: ['./terms.component.scss']
})
export class TermsComponent implements OnInit {
  checked: boolean = false;

  is_accepted: boolean = true;


  constructor(
    public onboardingService: OnboardingService,
    private toastr: ToastrService,
    private loaderService: LoaderService,
    public router: Router,
    public route: ActivatedRoute,
  ) {

    if (localStorage.getItem('has_onboarded') == "true") {
      this.router.navigate(['/onboarding/submitted']);
    }
  }

  ngOnInit() {
    // this.loaderService.display(true);

    // this.onboardingService.validateOnboarding().subscribe(
    //   res => {
    //     this.loaderService.display(false);
    //   },
    //   err => {
    //   	this.router.navigate(['/onboarding/machine-details']);
    //     this.loaderService.display(false);

    //     for(let i in err.error){
    //       this.toastr.error(err.error[i]);
    //     }
    //   }
    // );
  }

  acceptTerms(value) {    
    if (value) {
      this.is_accepted = false;
    }
    else {
      this.is_accepted = true;
    }
  }

  completeOnboarding() {
    var value = confirm("Are you sure you want to submit the profile? The profile can not be modified till the verification happens from Truventor team.")
    if (value) {
      this.loaderService.display(true);
      this.onboardingService.completeOnboarding().subscribe(
        (res: any) => {

          localStorage.setItem('has_onboarded', "true");
          this.loaderService.display(false);
          this.router.navigate(['/onboarding/submitted']);


        },
        err => {
          this.router.navigate(['/onboarding/machine-details']);
          this.loaderService.display(false);

          for (let i in err.error) {
            this.toastr.error(err.error[i]);
          }
        }
      );
    }
  }

  back() {
    this.router.navigate(['./onboarding/machine-details']);
  }

}
